export function isFinishSelectable(finish) {
    return Boolean(finish) && finish.enabled !== false
}

export function getCurrentFinishId(value) {
    if (!value) return null
    if (typeof value === 'object') return value.id || null
    return value
}

export function selectableFinishes(finishes, currentValue) {
    const list = Array.isArray(finishes) ? finishes : []
    const currentId = getCurrentFinishId(currentValue)
    return list.filter(
        finish =>
            isFinishSelectable(finish) ||
            (currentId != null && String(finish.id) === String(currentId))
    )
}
